import React, {useEffect} from "react";
import axios from "axios";
import {useTranslation} from "react-i18next";
import Divider from "antd/es/divider";
import List from "antd/es/list";
import RiseOutlined from "@ant-design/icons/lib/icons/RiseOutlined";
import FallOutlined from "@ant-design/icons/lib/icons/FallOutlined";
import ColumnWidthOutlined from "@ant-design/icons/lib/icons/ColumnWidthOutlined";
import { Space } from "antd"

export default () => {

    const {t} = useTranslation()

    let data = [
        {
            begin: 1,
            end: 62,
            title: t('patches.before11'),
        },
        {
            begin: 63,
            end: 67,
            title: new Date(Date.parse("2022/11/03")).toLocaleDateString(),
        },
        {
            begin: 68,
            end: 75,
            title: new Date(Date.parse("2022/11/06")).toLocaleDateString(),
        },
        {
            begin: 76,
            end: 83,
            title: new Date(Date.parse("2022/11/08")).toLocaleDateString(),
        },
        {
            begin: 84,
            end: 88,
            title: new Date(Date.parse("2022/11/13")).toLocaleDateString(),
        },
        {
            begin: 89,
            end: 90,
            title: new Date(Date.parse("2022/11/26")).toLocaleDateString(),
        },
        {
            begin: 91,
            end: 96,
            title: new Date(Date.parse("2022/11/29")).toLocaleDateString(),
        },
        {
            begin: 97,
            end: 99,
            title: new Date(Date.parse("2022/12/27")).toLocaleDateString(),
        },
        {
            begin: 100,
            end: 105,
            title: new Date(Date.parse("2023/1/7")).toLocaleDateString(),
        },
        {
            begin: 106,
            end: 109,
            title: new Date(Date.parse("2023/1/9")).toLocaleDateString(),
        },
        {
            begin: 110,
            end: 111,
            title: new Date(Date.parse("2023/1/20")).toLocaleDateString(),
        },
        {
            begin: 112,
            end: 116,
            title: new Date(Date.parse("2023/1/22")).toLocaleDateString(),
        },
        {
            begin: 117,
            end: 117,
            title: new Date(Date.parse("2023/1/24")).toLocaleDateString(),
        },
        {
            begin: 118,
            end: 119,
            title: new Date(Date.parse("2023/1/27")).toLocaleDateString(),
        },
        {
            begin: 120,
            end: 125,
            title: new Date(Date.parse("2023/1/30")).toLocaleDateString(),
        },
        {
            begin: 126,
            end: 130,
            title: new Date(Date.parse("2023/2/2")).toLocaleDateString(),
        },
        {
            begin: 131,
            end: 135,
            title: new Date(Date.parse("2023/2/4")).toLocaleDateString(),
        },
        {
            begin: 136,
            end: 137,
            title: new Date(Date.parse("2023/2/7")).toLocaleDateString(),
        },
        {
            begin: 138,
            end: 140,
            title: new Date(Date.parse("2023/2/24")).toLocaleDateString(),
        },
        {
            begin: 141,
            end: 145,
            title: new Date(Date.parse("2023/6/3")).toLocaleDateString(),
        },
        {
            begin: 146,
            end: 147,
            title: new Date(Date.parse("2023/6/5")).toLocaleDateString(),
        },
        {
            begin: 148,
            end: 150,
            title: new Date(Date.parse("2023/6/16")).toLocaleDateString(),
        },
        {
            begin: 151,
            end: 153,
            title: new Date(Date.parse("2023/7/17")).toLocaleDateString(),
        },
        {
            begin: 154,
            end: 154,
            title: new Date(Date.parse("2023/8/1")).toLocaleDateString(),
        },

        {
            list: [161,162,157,158,163,164,   159,155,156,166,167,169,174,175,176   ,160,165,168,170,171,172,173,177,178,179,180,181,182,183,184,185,186,187],
            title: new Date(Date.parse("2023/8/22")).toLocaleDateString(),
        },

        {
            begin: 188,
            end: 193,
            title: new Date(Date.parse("2023/8/29")).toLocaleDateString(),
        },
        {
            begin: 194,
            end: 196,
            title: new Date(Date.parse("2023/10/1")).toLocaleDateString(),
        },
        {
            begin: 197,
            end: 199,
            title: new Date(Date.parse("2023/11/13")).toLocaleDateString(),
        },
        {
            begin: 200,
            end: 221,
            title: new Date(Date.parse("2024/3/19")).toLocaleDateString(),
        },
        {
            begin: 222,
            end: 222,
            title: new Date(Date.parse("2024/11/14")).toLocaleDateString(),
        },
        {
            begin: 223,
            end: 228,
            title: new Date(Date.parse("2024/11/20")).toLocaleDateString(),
        },
        {
            begin: 229,
            end: 231,
            title: new Date(Date.parse("2024/11/23")).toLocaleDateString(),
        },
        {
            begin: 232,
            end: 234,
            title: new Date(Date.parse("2025/1/2")).toLocaleDateString(),
        },
        {
            begin: 235,
            end: 236,
            title: new Date(Date.parse("2025/1/14")).toLocaleDateString(),
        },
        {
            begin: 237,
            end: 242,
            title: new Date(Date.parse("2025/11/5")).toLocaleDateString(),
        },
    ]

    let conf = {

        200: {type: 2},
        201: {type: 2},
        202: {type: 3},
        203: {type: 1},
        204: {type: 1},
        205: {type: 1},
        206: {type: 1},
        207: {type: 2},
        208: {type: 3},
        209: {type: 1},
        210: {type: 1},
        211: {type: 2},
        212: {type: 1},
        213: {type: 2},
        214: {type: 2},
        215: {type: 1},
        216: {type: 1},
        217: {type: 2},
        218: {type: 3},
        219: {type: 1},
        220: {type: 2},
        221: {type: 2},
        222: {type: 1},

        223: {type: 2},
        224: {type: 3},
        225: {type: 3},
        226: {type: 1},
        227: {type: 2},
        228: {type: 1},
        229: {type: 1},
        230: {type: 1},
        231: {type: 1},

        232: {type: 1},
        233: {type: 1},
        234: {type: 1},
        235: {type: 1},
        236: {type: 1},

        237: {type: 1},
        238: {type: 1},
        239: {type: 1},
        240: {type: 2},
        241: {type: 1},
        242: {type: 1},

        157: {type: 3},
        158: {type: 3},
        159: {type: 2},
        160: {type: 1},
        155: {type: 2},
        156: {type: 2},
        161: {type: 3},
        162: {type: 3},
        163: {type: 3},
        164: {type: 3},
        165: {type: 1},
        166: {type: 2},
        167: {type: 2},
        168: {type: 1},
        169: {type: 2},
        170: {type: 1},
        171: {type: 1},
        172: {type: 1},
        173: {type: 1},
        174: {type: 2},
        175: {type: 2},
        176: {type: 2},
        177: {type: 1},
        178: {type: 1},
        179: {type: 1},
        180: {type: 1},
        181: {type: 1},
        182: {type: 1},
        183: {type: 1},
        184: {type: 1},
        185: {type: 1},
        186: {type: 1},
        187: {type: 1},
        188: {type: 1},
        189: {type: 1},
        190: {type: 1},
        191: {type: 1},
        192: {type: 1},
        193: {type: 1},
        194: {type: 3},
        195: {type: 2},
        196: {type: 2},
        197: {type: 2},
        198: {type: 1},
        199: {type: 1},

        97: {type: 3},
        98: {type: 1},
        99: {type: 1},
        100: {type: 2},
        101: {type: 1},
        102: {type: 1},
        103: {type: 3},
        104: {type: 3},
        105: {type: 3},
        106: {type: 1},
        107: {type: 1},
        108: {type: 1},
        109: {type: 1},
        110: {type: 3},
        111: {type: 1},
        112: {type: 1},
        113: {type: 2},
        114: {type: 2},
        115: {type: 2},
        116: {type: 3},
        117: {type: 2},
        118: {type: 3},
        119: {type: 3},
        120: {type: 3},
        121: {type: 1},
        122: {type: 2},
        123: {type: 2},
        124: {type: 3},
        125: {type: 3},
        126: {type: 3},
        127: {type: 3},
        128: {type: 2},
        129: {type: 2},
        130: {type: 3},
        131: {type: 1},
        136: {type: 3},
        137: {type: 1},
        138: {type: 3},
        139: {type: 2},
        140: {type: 2},

        141: {type: 3},
        142: {type: 1},
        143: {type: 2},
        144: {type: 1},
        145: {type: 1},

        146: {type: 3},
        147: {type: 1},

        148: {type: 3},
        149: {type: 1},
        150: {type: 2},
        151: {type: 2},
        152: {type: 3},
        153: {type: 3},

        154: {type: 3},

    }

    data = data.reverse()

    const typeIcon = {
        1: <RiseOutlined style={{ color: "#52c41a" }} />,
        2: <FallOutlined style={{ color: "#f5222d" }} />,
        3: <ColumnWidthOutlined style={{ color: "#fadb14" }} />,
    }

    for (const item of data) {
        item.data = []
        if (item.list) {
            for (let i of item.list) {
                item.data.push({
                    type: conf[i] ? conf[i].type : 0,
                    text: t(`patches.${i}`),
                    valid: `patches.${i}` !== t(`patches.${i}`),
                })
            }
        } else {
            for (let i = item.begin; i <= item.end; i++ ) {
                item.data.push({
                    type: conf[i] ? conf[i].type : 0,
                    text: t(`patches.${i}`),
                    valid: `patches.${i}` !== t(`patches.${i}`),
                })
            }
        }

        item.data = item.data.filter(i => i.valid)
    }

    useEffect(() => {
        localStorage.setItem("patches_read", `${data[0].title}#2`)
    }, [])


    return (<>

        {data.map(item => <div key={item.title}>
            <Divider orientation="left">{item.title}</Divider>
            <List
                align="left"
                size="small"
                bordered
                dataSource={item.data}
                renderItem={(item) => <List.Item>
                    <Space>
                        {
                            item.type ? typeIcon[item.type] : null
                        }{item.text}
                    </Space>
                </List.Item>}
            />
        </div>)}


    </>)
}
